import React from "react";
import Icon from "@ant-design/icons";

const UserGroupSvg = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
    >
        <path
            d="M10.4004 8.30106C11.1906 7.90834 11.7337 7.09285 11.7337 6.15053C11.7337 5.2082 11.1906 4.39272 10.4004 4"
            stroke="#165ABF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3996 12.7996C10.3996 11.0218 8.36884 9.59961 5.99961 9.59961C5.58632 9.59961 5.18332 9.64289 4.79961 9.72378C4.17081 9.85635 3.59379 10.0899 3.10808 10.3996C2.19111 10.9843 1.59961 11.8402 1.59961 12.7996H3.79961H5.99961H10.3996Z"
            fill="#165ABF"
        />
        <path
            d="M10.3996 12.7996V13.2996C10.6758 13.2996 10.8996 13.0758 10.8996 12.7996H10.3996ZM1.59961 12.7996H1.09961C1.09961 13.0758 1.32347 13.2996 1.59961 13.2996V12.7996ZM3.10808 10.3996L3.37689 10.8212V10.8212L3.10808 10.3996ZM4.79961 9.72378L4.69647 9.23454V9.23454L4.79961 9.72378ZM5.99961 9.59961V10.0996C7.08885 10.0996 8.08472 10.4275 8.79625 10.9389C9.50912 11.4513 9.89961 12.115 9.89961 12.7996H10.3996H10.8996C10.8996 11.7064 10.2747 10.7701 9.37989 10.1269C8.48373 9.48281 7.2796 9.09961 5.99961 9.09961V9.59961ZM1.59961 12.7996H2.09961C2.09961 12.0616 2.55533 11.345 3.37689 10.8212L3.10808 10.3996L2.83928 9.97801C1.82689 10.6235 1.09961 11.6188 1.09961 12.7996H1.59961ZM1.59961 12.7996V13.2996H3.79961V12.7996V12.2996H1.59961V12.7996ZM3.79961 12.7996V13.2996H5.99961V12.7996V12.2996H3.79961V12.7996ZM3.10808 10.3996L3.37689 10.8212C3.80828 10.5462 4.32845 10.3341 4.90275 10.213L4.79961 9.72378L4.69647 9.23454C4.01316 9.37859 3.37929 9.6337 2.83928 9.97801L3.10808 10.3996ZM4.79961 9.72378L4.90275 10.213C5.25268 10.1393 5.62111 10.0996 5.99961 10.0996V9.59961V9.09961C5.55152 9.09961 5.11397 9.14652 4.69647 9.23454L4.79961 9.72378ZM5.99961 12.7996V13.2996H10.3996V12.7996V12.2996H5.99961V12.7996Z"
            fill="#165ABF"
        />
        <path
            d="M14.4004 12.8004H14.9004C14.9004 12.933 14.8477 13.0602 14.7539 13.154C14.6602 13.2478 14.533 13.3004 14.4004 13.3004L14.4004 12.8004ZM12.8919 10.4004L13.1607 9.97884V9.97884L12.8919 10.4004ZM12.4004 13.3004C12.1242 13.3004 11.9004 13.0765 11.9004 12.8004C11.9004 12.5242 12.1243 12.3004 12.4004 12.3004L12.4004 12.8004L12.4004 13.3004ZM11.0972 10.2139C10.827 10.1569 10.6542 9.89167 10.7111 9.62147C10.7681 9.35126 11.0333 9.1784 11.3035 9.23536L11.2004 9.72461L11.0972 10.2139ZM14.4004 12.8004H13.9004C13.9004 12.0624 13.4447 11.3459 12.6231 10.822L12.8919 10.4004L13.1607 9.97884C14.1731 10.6243 14.9004 11.6196 14.9004 12.8004H14.4004ZM14.4004 12.8004L14.4004 13.3004L12.4004 13.3004L12.4004 12.8004L12.4004 12.3004L14.4004 12.3004L14.4004 12.8004ZM12.8919 10.4004L12.6231 10.822C12.1917 10.547 11.6715 10.3349 11.0972 10.2139L11.2004 9.72461L11.3035 9.23536C11.9868 9.37942 12.6207 9.63453 13.1607 9.97884L12.8919 10.4004Z"
            fill="#165ABF"
        />
        <path
            d="M6.3707 7.99922C7.69619 7.99922 8.7707 6.9247 8.7707 5.59922C8.7707 4.27374 7.69619 3.19922 6.3707 3.19922C5.04522 3.19922 3.9707 4.27374 3.9707 5.59922C3.9707 6.9247 5.04522 7.99922 6.3707 7.99922Z"
            fill="#165ABF"
            stroke="#165ABF"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const UserGroupIcon = (props) => {
    return <Icon component={UserGroupSvg} {...props} />;
};

export { UserGroupIcon };